import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
	LegalList,
	LegalPageLayout,
	LegalSection,
} from "#/components/legal/LegalPageLayout";

export const Route = createFileRoute("/privacy")({
	component: PrivacyPage,
});

function PrivacyPage() {
	const { t } = useTranslation("legal");
	const rawT = t as unknown as (key: string, opts: object) => string[];
	const tList = (key: string) => rawT(key, { returnObjects: true });

	return (
		<LegalPageLayout
			tag={t("privacy.tag")}
			title={t("privacy.title")}
			updated={t("privacy.updated")}
		>
			<p className="text-sm leading-relaxed text-muted-foreground">
				{t("privacy.intro")}
			</p>

			<LegalSection heading={t("privacy.controller.heading")}>
				<p>{t("privacy.controller.body")}</p>
			</LegalSection>

			<LegalSection heading={t("privacy.dataWeCollect.heading")}>
				<p>{t("privacy.dataWeCollect.intro")}</p>
				<LegalList items={tList("privacy.dataWeCollect.items")} />
			</LegalSection>

			<LegalSection heading={t("privacy.whyWeProcess.heading")}>
				<LegalList items={tList("privacy.whyWeProcess.items")} />
			</LegalSection>

			<LegalSection heading={t("privacy.sharing.heading")}>
				<p>{t("privacy.sharing.intro")}</p>
				<LegalList items={tList("privacy.sharing.items")} />
				<p>{t("privacy.sharing.outro")}</p>
			</LegalSection>

			<LegalSection heading={t("privacy.retention.heading")}>
				<p>{t("privacy.retention.body")}</p>
			</LegalSection>

			<LegalSection heading={t("privacy.cookies.heading")}>
				<p>{t("privacy.cookies.body")}</p>
			</LegalSection>

			<LegalSection heading={t("privacy.rights.heading")}>
				<p>{t("privacy.rights.intro")}</p>
				<LegalList items={tList("privacy.rights.items")} />
				<p>{t("privacy.rights.complaint")}</p>
			</LegalSection>

			<LegalSection heading={t("privacy.changes.heading")}>
				<p>{t("privacy.changes.body")}</p>
			</LegalSection>
		</LegalPageLayout>
	);
}
